import React from 'react';
import { Link } from 'react-router-dom';
import './SubBanner.css'

const SubBanner = () => {
    return (
        <section className='taglinewrap flex justify-center'>
            <div className="container-size">
                <h2>Get Started Today</h2>
                <p>Conveniently communicate economically sound leadership whereas turnkey content. Continually reintermediate highly efficient relationships before high-payoff e-tailers. Monotonectally.</p>

               <div className="lg:flex sm:block">
               <Link>
                Do you Want buy a car? <br />
                <span>Conveniently communicate economically sound  content</span>
                </Link>
                <Link className='sell'>
                Do you Want sell a car? <br />
                <span>Conveniently communicate economically sound  content</span>
                </Link>
               </div>
            </div>
        </section>
    );
};

export default SubBanner;